import { render, staticRenderFns } from "./CourseDayRow.vue?vue&type=template&id=712db32d&scoped=true&lang=pug&"
import script from "./CourseDayRow.vue?vue&type=script&lang=js&"
export * from "./CourseDayRow.vue?vue&type=script&lang=js&"
import style0 from "./CourseDayRow.vue?vue&type=style&index=0&id=712db32d&lang=scss&scoped=true&"
import style1 from "./CourseDayRow.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712db32d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCheckbox,VChip,VIcon,VMenu})
